import IconAdd from "./icon-add.svg";
import IconClose from "./icon-close.svg";
import IconDelete from "./icon-delete.svg";
import IconEdit from "./icon-edit.svg";
import IconCompanies from "./icon-companies.png";
import IconOffers from "./icon-offers.png";
import IconInvestors from "./icon-investors.png";
import IconLogout from "./icon-logout.png";
import IconSearch from "./icon-search.svg";
import IconCheckDark from "./icon-check-dark.svg";
import IconNotFound from "./icon-not-found.png";
import IconHighlightAwards from "./icon-highlight-awards.svg";
import IconHighlightMonetary from "./icon-highlight-monetary.svg";
import IconHighlightTeam from "./icon-highlight-team.svg";
import IconHighlightTechnology from "./icon-highlight-technology.svg";
import IconHighlightTraction from "./icon-highlight-traction.svg";
import IconHighlightVideo from "./icon-highlight-video.svg";
import IconBusinessModelCommission from "./icon-business-model-commission.svg"
import IconBusinessModelFreemium from "./icon-business-model-freemium.svg"
import IconBusinessModelHybrid from "./icon-business-model-hybrid.svg"
import IconBusinessModelService from "./icon-business-model-service.svg"
import IconBusinessModelSubscription from "./icon-business-model-subscription.svg"
import IconBusinessModelTransactional from "./icon-business-model-transactional.svg"

const highlightIcon = (type) => {
  switch(type){
    case 'monetary':
      return IconHighlightMonetary
    case 'award':
      return IconHighlightAwards ;
    case 'technology':
      return IconHighlightTechnology
    case 'team':
      return IconHighlightTeam
    case 'traction':
      return IconHighlightTraction
    default: 
      return null;
  }
}

const businessModelIcon = (name) => {
  switch(name){
    case 'Subscription/recurring payment':
      return IconBusinessModelSubscription
    case 'Transactional':
      return IconBusinessModelTransactional
    case 'Service':
      return IconBusinessModelService
    case 'Hybrid Pricing':
      return IconBusinessModelHybrid
    case 'Freemium':
      return IconBusinessModelFreemium
    case 'Commission':
      return IconBusinessModelCommission
    default: 
      return null;
  }
}

export {
  IconAdd,
  IconClose,
  IconDelete,
  IconEdit,
  IconCompanies,
  IconOffers,
  IconInvestors,
  IconLogout,
  IconSearch,
  IconCheckDark,
  IconNotFound,
  IconHighlightAwards,
  IconHighlightMonetary,
  IconHighlightTeam,
  IconHighlightTechnology,
  IconHighlightTraction,
  IconHighlightVideo,
  IconBusinessModelCommission,
  IconBusinessModelFreemium,
  IconBusinessModelHybrid,
  IconBusinessModelService,
  IconBusinessModelSubscription,
  IconBusinessModelTransactional,
  highlightIcon,
  businessModelIcon,
};